import {
  Card,
  CardTitle,
  CardHeader,
  CardContent,
  CardDescription,
} from '@design-system/Card';

import { Image } from '@design-system/Image';
import { getFoodImageUrl } from '@/utils/nutrition/getImageUrl';
import { StatusIndicator } from '@design-system/StatusIndicator';

export interface FoodRankCardProps extends React.ComponentProps<'div'> {
  title: string;
  color?: string;
  description: string;
  foodImages?: string[];
}

export const FoodRankCard = ({
  title,
  color,
  foodImages,
  description,
  ...rest
}: FoodRankCardProps) => {
  return (
    <Card {...rest} className="h-full flex flex-col">
      <CardHeader className="flex flex-col p-5 flex-grow">
        <CardTitle className="flex flex-row items-center gap-2">
          <abbr title={title} className="no-underline">
            <span className="typography-title text-primary truncate">
              {title}
            </span>
          </abbr>

          {color && <StatusIndicator color={color} className="ml-auto" />}
        </CardTitle>

        <CardDescription className="text-tertiary typography-caption2 line-clamp-3 mt-4 h-16 overflow-hidden">
          <abbr title={description} className="no-underline">
            {description}
          </abbr>
        </CardDescription>
      </CardHeader>

      <CardContent className="px-5 pb-5 flex flex-row [&>:not(:first-child)]:-ml-6 justify-start">
        {foodImages?.map((image, index) => (
          <div
            key={`${image}-${index}`}
            className="rounded-full border border-primary/5 bg-background-blur-medium size-16 flex justify-center items-center overflow-hidden bg-clip-padding backdrop-filter bg-opacity-10 backdrop-blur-md"
          >
            <Image
              width={44}
              height={44}
              aria-hidden
              src={getFoodImageUrl(image)}
              className="size-11 object-contain"
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
